<template lang="pug">
  .grid-list
    ul.flex
      li(v-for="(i, index) in items" :class="{clickable}" @click="click(i)")
        span {{i.name}}
          i.fa.pl5(v-if="removable" :class="{'fa-times': !defaultGroup || i.id !== defaultGroup}" @click.stop="removeClick(i, index)")
</template>

<script>
export default {
  props: ['items', 'clickable', 'removable', 'defaultGroup'],
  methods: {
    click(item) {
      if (this.clickable) {
        this.$emit('itemClick', item)
      }
    },
    removeClick(data, index) {
      if (this.removable) {
        this.$emit('removeClick', data, index)
      }
    }
  }
}
</script>

<style lang="scss">
.grid-list {
  .removable {
    cursor: pointer;
  }
  .clickable {
    color: blue;
  }
  ul.flex {
    margin: 0;
    padding: 0;
    list-style: none;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-flow: row wrap;
    -webkit-flex-flow: row wrap;
  }

  ul.flex li {
    box-sizing: border-box;
    padding: 3px;
  }

  ul.flex span {
    display: block;
    background: #eee;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 5px;
    text-align: center;
    font-size: 11px;
    line-height: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/PillsList.vue